<div class="row">
<p class="ptext" *ngIf="data == '25000'">At the moment our credit policy allows us to process a loan application only for individuals with a take home salary of <span style="color:red">INR 25000 or more</span> per month.</p>

<p class="ptext" *ngIf="data == '500000'">At the moment our credit policy allows us to process a loan application only for individuals with an annual income of <span style="color:red">INR 500,000</span> or more.</p>
<p class="ptext" *ngIf="data == '300000'">At the moment our credit policy allows us to process a loan application only for individuals with an annual income of <span style="color:red">INR 300,000</span> or more.</p>

<p class="ptext">We have your loan application details. You can come back complete the loan application when you meet the necessary criteria.
</p>
</div>

<div class="row">
<div class="col-sm-6 div1">
	<button mat-stroked-button class="primary" (click)="logout(); analyticsTracker.trackButtonClick('I understand, Log me out', 'About your work pop-up');">I understand, Log me out</button>
</div>
<div class="col-sm-6 div2">
	<button mat-flat-button class="primary" (click)="closeModal(); analyticsTracker.trackButtonClick('Go back to my Application', 'About your work pop-up');">Go back to my Application</button>
</div>

</div>
